<template>
  <v-card>
    <slot name="heading" v-bind:content="editorData"/>
    <ckeditor
      :editor="editor"
      v-model="editorData"
      :config="editorConfig"
      @ready="onReady"
    />
  </v-card>
</template>

<script>
import CKEditor from "@ckeditor/ckeditor5-vue";
import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
export default {
  name: "BaseRichTextEditor",
  components: {
    // Use the <ckeditor> component in this view.
    ckeditor: CKEditor.component
  },
  props: {
    // designate read-only status
    isReadOnly: {
      type: Boolean,
      required: true,
      default: true
    },
    // the actual string for editing
    content: {
      type: String,
      required: true,
      default: "Placeholder"
    }
  },
  data() {
    return {
      editor: DecoupledEditor,
      editorData: this.content,
      editorConfig: {
        toolbar: [
          "heading",
          "|",
          "fontSize",
          "fontFamily",
          "bold",
          "italic",
          "underline",
          "strikethrough",
          "highlight",
          "|",
          "alignment",
          "numberedList",
          "bulletedList",
          "insertTable",
          "outdent",
          "indent"
        ]
      }
    };
  },
  methods: {
    onReady(editor) {
      // Insert the toolbar before the editable area.
      editor.ui
        .getEditableElement()
        .parentElement.insertBefore(
          editor.ui.view.toolbar.element,
          editor.ui.getEditableElement()
        );
      if (this.isReadOnly) {
        editor.isReadOnly = true;
      }
    }
  }
};
</script>
